import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchLocation from "../../../searchLocation/searchLocation";

toast.configure()

const ValetEditAccount = ({
                           locationPinCode,
                           pincodeData,
                           locationCity,
                           locationZone,
                           locationArea,
                           cities = [],
                           zones = [],
                           areas = [],
                           saveAccount,
                           saveDetails = [],
                           accountDetailsByIdData = [],
                           match,
                           history,
                           accountById
                       }) => {

    let validRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    const [pocDetails, addPOCDetails] = useState([{
        name: '',
        designation: '',
        email: '',
        number: '',
        company_name: ''
    }])
    const [inputSiteList, setInputList] = useState([{
        client_name: '',
        address_1: '',
        address_2: '',
        client_lat: '',
        client_long: '',
        project_type: '',
        pincode: '',
        area_id: '',
        latitude: '',
        longitude: '',
        solution_type: 'null',
        business_model: '',
        source: '',
        monthly_user_projected: '',
        revenue_projected: '',
        operation_timing: '',
        daily_vehicle_football: '',
        daily_expected_pickup: '',
        dedicated_manpower_available: '',
        manpower_last_shift_time: '',
        smartphone_available_manpower: '',
        is_gmc_enabled: '',
        payment_flow_required: '',
        is_online_payment_enabled: '',
        client_aligned_duty_auto_assignment_flow: '',
        client_aligned_duty_photo_click: '',
        client_aligned_deprecate_physical_tag: '',
        valet_driver_name: '',
        valet_driver_phone_no: '',
        valet_supervisor_name: '',
        valet_supervisor_phone_no: '',
        parking_zone_slot_capacity: '',
        valet_solution_present:'',
        valet_solution_present_yes:'',
        other_source:''
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)

    const [pincode, setPincode] = useState([]);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [userMessage, setUserMessage] = useState('')
    const [redirectUrl, setRedirectUrl] = useState('')
    const [isView, setIsView] = useState(false)
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState("")
    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const [pincodeValue, setPincodeValue] = useState('')
    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)

    useEffect(() => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
    }, [])

    useEffect(() => {
        (async () => {
            setIsView(false)
            var split = document.URL.split("/");
            if (localStorage.getItem('userId') !== undefined) {
                setUserId(localStorage.getItem('user_id'))
            }

            if (split.includes('view-account')) {
                setIsView(true)
            }
            setIsLoading(true)
            await locationCity()
            if (match?.params?.id !== undefined) {
                await accountById(match?.params?.id)
                setIsEdit(true)
            }
            setIsLoading(false)
        })()
    }, [])


    const handleInput = (val, index) => {
        const list = [...inputSiteList]
        list[0][index] = val
        setInputList(list)
    }

    const handlePocInput = (val, index, i) => {
        const list = [...pocDetails]
        list[i][index] = val
        addPOCDetails(list)
    }

    const getCityStateByPincode = async (pincode) => {
        if (pincode === '') {
            return false
        }
        await locationPinCode(pincode)
    }

    useEffect(() => {
        setPincode([])
        setTimeout(() => {
            setIsLoading(true)
            if (pincodeData && pincodeData.length > 0) {
                setPincode(pincodeData[0])
            }
            setIsLoading(false)
        }, 1000)
    }, [pincodeData])

    const handleAddPOC = () => {
        // const list = [...pocDetails]
        addPOCDetails([
            ...pocDetails,
            {
                name: '',
                city: '',
                designation: '',
                email: '',
                number: '',
                designation_type_id: ''
            }
        ])
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(saveDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(saveDetails?.message)
            setRedirectUrl('valet-opportunity-list/' + match?.params?.id)
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(saveDetails?.message)
        }
    }, [saveDetails])


    const [projectTypeId, setProjectTypeId] = useState('')

    useEffect(() => {
        if (match?.params?.id !== undefined) {
            (async () => {
                setIsLoading(true)
                await accountById(match?.params?.id)
                setIsLoading(false)
            })()
        }
    }, [match.params.id])

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            (async () => {
                await locationPinCode(accountDetailsByIdData?.pincode)
            })()
            setIsEdit(true)
            setProjectTypeId(accountDetailsByIdData?.project_type)
            if (accountDetailsByIdData?.poc_details !== [] && accountDetailsByIdData?.poc_details.length > 0) {
                addPOCDetails(accountDetailsByIdData?.poc_details)
            }

            var split = document.URL.split("/");
            if (split.includes('edit-account') && parseInt(accountDetailsByIdData?.stage) === 11) {
                toast.error("You can't update account details now")
                window.location.href = "view-account/" + match?.params?.id
            }
            // if(parseInt(accountDetailsByIdData?.is_draft) === 1){
            //     setIsView(false)
            // }
        }
    }, [accountDetailsByIdData])


    useEffect(() => {
        if (accountDetailsByIdData?.data !== undefined) {
            handleInput(accountDetailsByIdData?.data?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.data?.solution_type, 'solution_type')
            handleInput(accountDetailsByIdData?.data?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.data?.longitude, 'longitude')
            handleInput(accountDetailsByIdData?.data?.pincode, 'pincode')
            handleInput(accountDetailsByIdData?.data?.address_1, 'address_1')
            handleInput(accountDetailsByIdData?.data?.parking_zone_slot_capacity, 'parking_zone_slot_capacity')
            handleInput(accountDetailsByIdData?.data?.valet_supervisor_phone_no, 'valet_supervisor_phone_no')
            handleInput(accountDetailsByIdData?.data?.valet_supervisor_name, 'valet_supervisor_name')
            handleInput(accountDetailsByIdData?.data?.valet_driver_phone_no, 'valet_driver_phone_no')
            handleInput(accountDetailsByIdData?.data?.valet_driver_name, 'valet_driver_name')
            handleInput(accountDetailsByIdData?.data?.client_aligned_duty_photo_click, 'client_aligned_duty_photo_click')
            handleInput(accountDetailsByIdData?.data?.client_aligned_duty_auto_assignment_flow, 'client_aligned_duty_auto_assignment_flow')
            handleInput(accountDetailsByIdData?.data?.payment_flow_required, 'payment_flow_required')
            handleInput(accountDetailsByIdData?.data?.is_gmc_enabled, 'is_gmc_enabled')
            handleInput(accountDetailsByIdData?.data?.dedicated_manpower_available, 'dedicated_manpower_available')
            handleInput(accountDetailsByIdData?.data?.daily_expected_pickup, 'daily_expected_pickup')
            handleInput(accountDetailsByIdData?.data?.daily_vehicle_football, 'daily_vehicle_football')
            handleInput(accountDetailsByIdData?.data?.operation_timing, 'operation_timing')
            handleInput(accountDetailsByIdData?.data?.revenue_projected, 'revenue_projected')
            handleInput(accountDetailsByIdData?.data?.source, 'source')
            handleInput(accountDetailsByIdData?.data?.business_model, 'business_model')
            handleInput(accountDetailsByIdData?.data?.solution_type, 'solution_type')
            handleInput(accountDetailsByIdData?.data?.monthly_user_projected, 'monthly_user_projected')
            handleInput(accountDetailsByIdData?.data?.manpower_last_shift_time, 'manpower_last_shift_time')
            handleInput(accountDetailsByIdData?.data?.smartphone_available_manpower, 'smartphone_available_manpower')
            handleInput(accountDetailsByIdData?.data?.is_online_payment_enabled, 'is_online_payment_enabled')
            handleInput(accountDetailsByIdData?.data?.client_aligned_deprecate_physical_tag, 'client_aligned_deprecate_physical_tag')
            handleInput(accountDetailsByIdData?.data?.valet_solution_present?.valet_solution_present, 'valet_solution_present')
            handleInput(accountDetailsByIdData?.data?.valet_solution_present?.valet_solution_present_yes, 'valet_solution_present_yes')
            setCityId(accountDetailsByIdData?.data?.city_id)
            setAreaId(accountDetailsByIdData?.data?.area_id)
            setZoneId(accountDetailsByIdData?.data?.zone_id)
            handleInput(accountDetailsByIdData?.data?.geographical_city_id, 'geographical_city_id')
            handleInput(accountDetailsByIdData?.data?.geographical_state_id, 'geographical_state_id')
            handleInput(accountDetailsByIdData?.data?.project_type, 'project_type')
            handleInput(accountDetailsByIdData?.data?.name_of_referrer, 'other_source')
            setLat(accountDetailsByIdData?.data?.latitude)
            setLong(accountDetailsByIdData?.data?.longitude)
            setPincodeValue(accountDetailsByIdData?.data?.pincode)
            setOptOption({...optOption, currentLocation: accountDetailsByIdData?.data?.current_location});
            if(accountDetailsByIdData?.data?.poc_details && accountDetailsByIdData?.data?.poc_details.length > 0){
                addPOCDetails(accountDetailsByIdData?.data?.poc_details)
            }

        }
    }, [accountDetailsByIdData])

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputSiteList[0]

        let isEmailValid = true
        let msg = ''
        pocDetails.map((val, i) => {
            if (!val?.email.match(validRegex)) {
                msg = "Enter valid email for " + val.name
                isEmailValid = false
            }
        })

        if (!isEmailValid) {
            toast.error(msg)
            return false
        }


        if (requestParams['client_name'] === '') {
            toast.error('Site name is required')
            return false
        }

        requestParams['poc_details'] = pocDetails
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        requestParams['area_id'] = areaId
        requestParams['client_lat'] = islatlng?.lat
        requestParams['client_long'] = islatlng?.lng
        requestParams['is_draft'] = false
        requestParams['area_id'] = areaId
        requestParams['city_id'] = cityId
        requestParams['zone_id'] = zoneId
        requestParams['valet_solution_present'] = {valet_solution_present:requestParams['valet_solution_present'], valet_solution_present_yes: requestParams['valet_solution_present_yes']}
        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return false
        if (requestParams['latitude'] == null || requestParams['longitude'] == null || requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        // return false
        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
        }
        await saveAccount(requestParams)
        setIsLoading(false)
    }


    const handleDraft = async (e) => {
        e.preventDefault()
        let requestParams = inputSiteList[0]

        if (requestParams['project_type'] === '') {
            toast.error("Please select site type")
            return false
        }

        if (requestParams['client_name'] === '') {
            toast.error('Site name is required')
            return false
        }


        requestParams['is_draft'] = true
        requestParams['poc_details'] = pocDetails
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        requestParams['client_lat'] = mapLocation?.lat
        requestParams['client_long'] = mapLocation?.lng
        requestParams['area_id'] = areaId
        requestParams['city_id'] = cityId
        requestParams['zone_id'] = zoneId
        requestParams['valet_solution_present'] = {valet_solution_present:requestParams['valet_solution_present'], valet_solution_present_yes: requestParams['valet_solution_present_yes']}

        if (requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
        }
        // console.log("requestParams "+JSON.stringify(requestParams) )
        await saveAccount(requestParams)
        setIsLoading(false)
    }

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({...optOption, currentLocation: value});
        handleInput(value, 'current_location')
        handleInput(value, 'address_1')
    };

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.data?.city_id)
        })()
    }, [cityId, accountDetailsByIdData])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !== 0 ? zoneId : accountDetailsByIdData?.data?.zone_id)
        })()
    }, [zoneId, accountDetailsByIdData])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Site Details'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                {/*Heading*/}
                                <div className="hide d-sm-flex align-items-center justify-content-between com-heading">
                                    <h1 className="h3 mb-0 text-black-100">Add Account</h1>
                                </div>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Site Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field">
                                                            <select className="form-control"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'business_model')
                                                                    }} >
                                                                <option value="">Select Business Model</option>
                                                                <option value="Revenue"
                                                                        selected={inputSiteList[0].business_model === "Revenue"}>Revenue
                                                                </option>
                                                                <option value="Cost"
                                                                        selected={inputSiteList[0].business_model === "Cost"}>Cost
                                                                </option>

                                                            </select>

                                                            <label className="large-label float-lb">
                                                                Business Model
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <select className="form-control"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'valet_solution_present')
                                                                    }} >
                                                                <option value="">Select Valet Solution Present
                                                                </option>
                                                                <option value="Yes"
                                                                        selected={inputSiteList[0].valet_solution_present === "Yes"}>Yes
                                                                </option>
                                                                <option value="No"
                                                                        selected={inputSiteList[0].valet_solution_present === "No"}>No
                                                                </option>

                                                            </select>

                                                            <label className="large-label float-lb">
                                                                Valet Solution Present
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        {inputSiteList[0].valet_solution_present === 'Yes' &&
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'valet_solution_present_yes')
                                                                       }}
                                                                       value={inputSiteList[0]?.valet_solution_present_yes}
                                                                       required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Solution Present <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                        }
                                                        <div className="col-md-6 float-field">
                                                            <select className="form-control"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'source')
                                                                    }} >
                                                                <option value="">Select Source</option>
                                                                <option
                                                                    value="Referral - Client"
                                                                    selected={inputSiteList[0].source === "Enquiry - Client"}>Referral
                                                                    - Client
                                                                </option>
                                                                <option
                                                                    value="Referral - Team (Internal)"
                                                                    selected={inputSiteList[0].source === "Enquiry - Team (Internal)"}>Referral
                                                                    - Team (Internal)
                                                                </option>
                                                                <option
                                                                    value="Enquiry - Existing Site"
                                                                    selected={inputSiteList[0].source === "Enquiry - Existing Site"}>Enquiry
                                                                    - Existing Site
                                                                </option>
                                                                <option
                                                                    value="Enquiry - Inbound"
                                                                    selected={inputSiteList[0].source === "Enquiry - Inbound"}>Enquiry
                                                                    - Inbound
                                                                </option>
                                                                <option
                                                                    value="Enquiry - Outbound"
                                                                    selected={inputSiteList[0].source === "Enquiry - Outbound"}>Enquiry
                                                                    - Outbound
                                                                </option>
                                                                <option
                                                                    value="Others"
                                                                    selected={inputSiteList[0].source === "Others"}>Others
                                                                </option>
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Source
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        {inputSiteList[0].source === "Others" &&
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'other_source')
                                                                       }}
                                                                       value={inputSiteList[0]?.other_source}
                                                                       required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Source <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                        }
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'monthly_user_projected')
                                                                   }}
                                                                   value={inputSiteList[0]?.monthly_user_projected}
                                                                   // required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Daily User Projected
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'revenue_projected')
                                                                   }}
                                                                   value={inputSiteList[0]?.revenue_projected}
                                                                   // required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Monthly Revenue Projected
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'operation_timing')
                                                                   }}
                                                                   value={inputSiteList[0]?.operation_timing}
                                                                   // required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Operation Timing
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'daily_vehicle_football')
                                                                   }}
                                                                   value={inputSiteList[0]?.daily_vehicle_football}
                                                                   // required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Daily Vehicle Footfall
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput(e.target.value, 'daily_expected_pickup')
                                                                   }}
                                                                   value={inputSiteList[0]?.daily_expected_pickup}
                                                                   // required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Daily Expected Pickup
                                                                {/*<i*/}
                                                                {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <>
                                            <div className="col-sm-12 mb-4">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    Update
                                                </button>
                                            </div>
                                        </>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default ValetEditAccount